const adminMenuItems = [{
    //url: "/",
    name: "Lotto Manage",
    //slug: "home",
    icon: "BoxIcon",
    submenu: [{
        url: '/',
        name: 'Lotto Result',
        slug: 'admin-lotto-results'
      },
      {
        url: '/add-results',
        name: 'Add Round',
        slug: 'admin-add-results'
      }
    ]
  },
  /*{
    //url: '/member',
    name: 'Member',
    //slug: 'admin-members',
    icon: 'UsersIcon',
    submenu: [{
        url: '/member',
        name: 'All Member',
        slug: 'admin-members'
      },
      {
        url: '/member/new',
        name: 'Add Member',
        slug: 'admin-member-new'
      }
    ]
  }*/
]

const memberMenuItems = [{
  url: "/",
  name: "Home",
  slug: "home",
  icon: "BoxIcon"
}]

export { adminMenuItems, memberMenuItems }
